module.exports = __webpack_public_path__ + "static/img/news82_12.cd7204b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news82/news82_12.webp
// module id = F3oS
// module chunks = 0